module.exports = __webpack_public_path__ + "static/media/NathanielB.1428fb4a.jpg";